export const HomeModifyResend = {
  HomeModifyResendCard: {
    ButtonTitle: '修正・再送信する',
  },
};
